/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Heading1Inputs */

const zh_landing_workflow_heading1 = /** @type {(inputs: Landing_Workflow_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的教学流程，`)
};

const en_landing_workflow_heading1 = /** @type {(inputs: Landing_Workflow_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your teaching workflow,`)
};

const es_landing_workflow_heading1 = /** @type {(inputs: Landing_Workflow_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu flujo de enseñanza,`)
};

/**
* | output |
* | --- |
* | "Your teaching workflow," |
*
* @param {Landing_Workflow_Heading1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_heading1 = /** @type {((inputs?: Landing_Workflow_Heading1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Heading1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_heading1(inputs)
	if (locale === "en") return en_landing_workflow_heading1(inputs)
	return es_landing_workflow_heading1(inputs)
});